<template>
    <div>
        <v-dialog v-model="dialog" width="500">
            <v-card>
                <v-card-text class="std-padding">
                    <h5>{{ text }}</h5>

                    <p v-if="description">{{ description }}</p>
                </v-card-text>
        
                <v-divider />
        
                <v-card-actions>
                    <v-spacer />
                    <div class="std-padding-side">
                        <v-btn color="primary" flat @click="dialog = false">Cancel </v-btn>
                        <v-btn color="primary" @click="confirmYes()">Yes </v-btn>
                    </div>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>

export default {
    data () {
        return {
            dialog: false,
            text: "Are you sure to delete the item ?",
            id: "",
            name: "",
            link: "",
            description: "",
            receivingMethodName: "",
        };
    },
    mounted () {
        var self = this;
        EventBus.$on("confirmDialog", function (object) {
            self.dialog              = true;
            self.text                = object.text;
            self.description         = object.description;
            self.id                  = object.id;
            self.name                = object.name;
            self.link                = object.link;
            self.receivingMethodName = object.receivingMethodName;
        });
    },
    methods: {
        confirmYes() {
            this.dialog = false;
            this.$emit("confirmYes", this.receivingMethodName);
        }
    }
};
</script>


// WEBPACK FOOTER //
// src/components/buttons/ComfirmationDialog.vue